import { useState } from "react";
import { streamItems } from "@/mocks/home";
import SectionHead from "./SectionHead";

const LEVEL_STYLE: Record<string, string> = {
  "🔥 高热": "bg-primary-600 text-background-50",
  "高热": "bg-primary-600 text-background-50",
  "新瓜": "bg-accent-500 text-foreground-950",
  "追踪": "bg-secondary-700 text-background-50",
  "热议": "bg-background-900 text-background-50",
};

export default function NewsStream() {
  const all = ["全部", ...Array.from(new Set(streamItems.map((s) => s.tag)))];
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? streamItems : streamItems.filter((s) => s.tag === active);

  return (
    <section id="stream" className="scroll-mt-24">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1 text-xs font-medium tracking-wider text-foreground-600">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              FEED
            </div>
            <h2 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-3xl">
              最新爆料
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              大图卡片流连续刷新，最新一条带实时角标，旧瓜按热度归档。
            </p>
          </div>
          <a
            href="#download"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-secondary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-700"
          >
            <i className="ri-notification-3-line text-sm" />
            订阅更新提醒
          </a>
        </div>

        {/* filter chips */}
        <div className="no-scrollbar mt-5 flex gap-2 overflow-x-auto pb-1">
          {all.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={`shrink-0 whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === t
                  ? "bg-foreground-950 text-background-50"
                  : "border border-background-200 bg-background-50 text-foreground-600 hover:bg-background-100"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* big image card stream */}
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((s) => (
            <a
              key={s.title}
              href="#stream"
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden">
                <img
                  src={s.image}
                  alt={`${s.tag}题材：${s.title}配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded bg-foreground-950/80 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
                  {s.tag}
                </span>
                <span
                  className={`absolute right-3 top-3 rounded px-2 py-0.5 text-[11px] font-bold ${LEVEL_STYLE[s.level] || "bg-secondary-700 text-background-50"}`}
                >
                  {s.level}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="clamp-2 font-heading text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                  {s.title}
                </h3>
                <p className="clamp-2 mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                <div className="mt-auto flex items-center gap-4 pt-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {s.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {s.read}
                  </span>
                  <span className="ml-auto flex items-center gap-1 text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                    详情
                    <i className="ri-arrow-right-line text-xs" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="#topic"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看更多旧瓜
            <i className="ri-loader-3-line" />
          </a>
        </div>
      </div>
    </section>
  );
}